/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as CallbackOauth1RouteImport } from './routes/callback.oauth1'
import { Route as CallbackGitRouteImport } from './routes/callback.git'
import { Route as AuthProjectsRouteImport } from './routes/_auth/projects'
import { Route as AuthCreateRouteImport } from './routes/_auth/create'
import { Route as AuthAccountRouteImport } from './routes/_auth/account'
import { Route as AuthAcceptInvitationRouteImport } from './routes/_auth/accept-invitation'
import { Route as AuthAppLayoutRouteImport } from './routes/_auth/_appLayout'
import { Route as AuthHomeIndexRouteImport } from './routes/_auth/home/index'
import { Route as AuthAppLayoutIndexRouteImport } from './routes/_auth/_appLayout/index'
import { Route as ConnectionsOauth2CallbackRouteImport } from './routes/connections.oauth2.callback'
import { Route as AuthProjectsProjectIdRouteImport } from './routes/_auth/projects.$projectId'
import { Route as AuthIntegrationsProjectIdRouteImport } from './routes/_auth/integrations.$projectId'
import { Route as AuthHomeIssuesRouteImport } from './routes/_auth/home/issues'
import { Route as AuthHomeIntegrationsRouteImport } from './routes/_auth/home/integrations'
import { Route as AuthHomeAutomationsRouteImport } from './routes/_auth/home/automations'
import { Route as AuthAppLayoutResourcesRouteImport } from './routes/_auth/_appLayout/resources'
import { Route as AuthAppLayoutIssuesRouteImport } from './routes/_auth/_appLayout/issues'
import { Route as AuthAppLayoutIntegrationsRouteImport } from './routes/_auth/_appLayout/integrations'
import { Route as AuthAppLayoutAutomationsRouteImport } from './routes/_auth/_appLayout/automations'
import { Route as AuthAutomationsAutomationIdIndexRouteImport } from './routes/_auth/automations/$automationId/index'
import { Route as AuthAutomationsAutomationIdRunsRunIdRouteImport } from './routes/_auth/automations/$automationId/runs/$runId'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackOauth1Route = CallbackOauth1RouteImport.update({
  id: '/callback/oauth1',
  path: '/callback/oauth1',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackGitRoute = CallbackGitRouteImport.update({
  id: '/callback/git',
  path: '/callback/git',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthProjectsRoute = AuthProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCreateRoute = AuthCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAccountRoute = AuthAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAcceptInvitationRoute = AuthAcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAppLayoutRoute = AuthAppLayoutRouteImport.update({
  id: '/_appLayout',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHomeIndexRoute = AuthHomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAppLayoutIndexRoute = AuthAppLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAppLayoutRoute,
} as any)
const ConnectionsOauth2CallbackRoute =
  ConnectionsOauth2CallbackRouteImport.update({
    id: '/connections/oauth2/callback',
    path: '/connections/oauth2/callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthProjectsProjectIdRoute = AuthProjectsProjectIdRouteImport.update({
  id: '/$projectId',
  path: '/$projectId',
  getParentRoute: () => AuthProjectsRoute,
} as any)
const AuthIntegrationsProjectIdRoute =
  AuthIntegrationsProjectIdRouteImport.update({
    id: '/integrations/$projectId',
    path: '/integrations/$projectId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthHomeIssuesRoute = AuthHomeIssuesRouteImport.update({
  id: '/home/issues',
  path: '/home/issues',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHomeIntegrationsRoute = AuthHomeIntegrationsRouteImport.update({
  id: '/home/integrations',
  path: '/home/integrations',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHomeAutomationsRoute = AuthHomeAutomationsRouteImport.update({
  id: '/home/automations',
  path: '/home/automations',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAppLayoutResourcesRoute = AuthAppLayoutResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => AuthAppLayoutRoute,
} as any)
const AuthAppLayoutIssuesRoute = AuthAppLayoutIssuesRouteImport.update({
  id: '/issues',
  path: '/issues',
  getParentRoute: () => AuthAppLayoutRoute,
} as any)
const AuthAppLayoutIntegrationsRoute =
  AuthAppLayoutIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthAppLayoutRoute,
  } as any)
const AuthAppLayoutAutomationsRoute =
  AuthAppLayoutAutomationsRouteImport.update({
    id: '/automations',
    path: '/automations',
    getParentRoute: () => AuthAppLayoutRoute,
  } as any)
const AuthAutomationsAutomationIdIndexRoute =
  AuthAutomationsAutomationIdIndexRouteImport.update({
    id: '/automations/$automationId/',
    path: '/automations/$automationId/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAutomationsAutomationIdRunsRunIdRoute =
  AuthAutomationsAutomationIdRunsRunIdRouteImport.update({
    id: '/automations/$automationId/runs/$runId',
    path: '/automations/$automationId/runs/$runId',
    getParentRoute: () => AuthRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthAppLayoutIndexRoute
  '/accept-invitation': typeof AuthAcceptInvitationRoute
  '/account': typeof AuthAccountRoute
  '/create': typeof AuthCreateRoute
  '/projects': typeof AuthProjectsRouteWithChildren
  '/callback/git': typeof CallbackGitRoute
  '/callback/oauth1': typeof CallbackOauth1Route
  '/automations': typeof AuthAppLayoutAutomationsRoute
  '/integrations': typeof AuthAppLayoutIntegrationsRoute
  '/issues': typeof AuthAppLayoutIssuesRoute
  '/resources': typeof AuthAppLayoutResourcesRoute
  '/home/automations': typeof AuthHomeAutomationsRoute
  '/home/integrations': typeof AuthHomeIntegrationsRoute
  '/home/issues': typeof AuthHomeIssuesRoute
  '/integrations/$projectId': typeof AuthIntegrationsProjectIdRoute
  '/projects/$projectId': typeof AuthProjectsProjectIdRoute
  '/connections/oauth2/callback': typeof ConnectionsOauth2CallbackRoute
  '/home/': typeof AuthHomeIndexRoute
  '/automations/$automationId/': typeof AuthAutomationsAutomationIdIndexRoute
  '/automations/$automationId/runs/$runId': typeof AuthAutomationsAutomationIdRunsRunIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthAppLayoutIndexRoute
  '/accept-invitation': typeof AuthAcceptInvitationRoute
  '/account': typeof AuthAccountRoute
  '/create': typeof AuthCreateRoute
  '/projects': typeof AuthProjectsRouteWithChildren
  '/callback/git': typeof CallbackGitRoute
  '/callback/oauth1': typeof CallbackOauth1Route
  '/automations': typeof AuthAppLayoutAutomationsRoute
  '/integrations': typeof AuthAppLayoutIntegrationsRoute
  '/issues': typeof AuthAppLayoutIssuesRoute
  '/resources': typeof AuthAppLayoutResourcesRoute
  '/home/automations': typeof AuthHomeAutomationsRoute
  '/home/integrations': typeof AuthHomeIntegrationsRoute
  '/home/issues': typeof AuthHomeIssuesRoute
  '/integrations/$projectId': typeof AuthIntegrationsProjectIdRoute
  '/projects/$projectId': typeof AuthProjectsProjectIdRoute
  '/connections/oauth2/callback': typeof ConnectionsOauth2CallbackRoute
  '/home': typeof AuthHomeIndexRoute
  '/automations/$automationId': typeof AuthAutomationsAutomationIdIndexRoute
  '/automations/$automationId/runs/$runId': typeof AuthAutomationsAutomationIdRunsRunIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_auth/_appLayout': typeof AuthAppLayoutRouteWithChildren
  '/_auth/accept-invitation': typeof AuthAcceptInvitationRoute
  '/_auth/account': typeof AuthAccountRoute
  '/_auth/create': typeof AuthCreateRoute
  '/_auth/projects': typeof AuthProjectsRouteWithChildren
  '/callback/git': typeof CallbackGitRoute
  '/callback/oauth1': typeof CallbackOauth1Route
  '/_auth/_appLayout/automations': typeof AuthAppLayoutAutomationsRoute
  '/_auth/_appLayout/integrations': typeof AuthAppLayoutIntegrationsRoute
  '/_auth/_appLayout/issues': typeof AuthAppLayoutIssuesRoute
  '/_auth/_appLayout/resources': typeof AuthAppLayoutResourcesRoute
  '/_auth/home/automations': typeof AuthHomeAutomationsRoute
  '/_auth/home/integrations': typeof AuthHomeIntegrationsRoute
  '/_auth/home/issues': typeof AuthHomeIssuesRoute
  '/_auth/integrations/$projectId': typeof AuthIntegrationsProjectIdRoute
  '/_auth/projects/$projectId': typeof AuthProjectsProjectIdRoute
  '/connections/oauth2/callback': typeof ConnectionsOauth2CallbackRoute
  '/_auth/_appLayout/': typeof AuthAppLayoutIndexRoute
  '/_auth/home/': typeof AuthHomeIndexRoute
  '/_auth/automations/$automationId/': typeof AuthAutomationsAutomationIdIndexRoute
  '/_auth/automations/$automationId/runs/$runId': typeof AuthAutomationsAutomationIdRunsRunIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invitation'
    | '/account'
    | '/create'
    | '/projects'
    | '/callback/git'
    | '/callback/oauth1'
    | '/automations'
    | '/integrations'
    | '/issues'
    | '/resources'
    | '/home/automations'
    | '/home/integrations'
    | '/home/issues'
    | '/integrations/$projectId'
    | '/projects/$projectId'
    | '/connections/oauth2/callback'
    | '/home/'
    | '/automations/$automationId/'
    | '/automations/$automationId/runs/$runId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invitation'
    | '/account'
    | '/create'
    | '/projects'
    | '/callback/git'
    | '/callback/oauth1'
    | '/automations'
    | '/integrations'
    | '/issues'
    | '/resources'
    | '/home/automations'
    | '/home/integrations'
    | '/home/issues'
    | '/integrations/$projectId'
    | '/projects/$projectId'
    | '/connections/oauth2/callback'
    | '/home'
    | '/automations/$automationId'
    | '/automations/$automationId/runs/$runId'
  id:
    | '__root__'
    | '/_auth'
    | '/_auth/_appLayout'
    | '/_auth/accept-invitation'
    | '/_auth/account'
    | '/_auth/create'
    | '/_auth/projects'
    | '/callback/git'
    | '/callback/oauth1'
    | '/_auth/_appLayout/automations'
    | '/_auth/_appLayout/integrations'
    | '/_auth/_appLayout/issues'
    | '/_auth/_appLayout/resources'
    | '/_auth/home/automations'
    | '/_auth/home/integrations'
    | '/_auth/home/issues'
    | '/_auth/integrations/$projectId'
    | '/_auth/projects/$projectId'
    | '/connections/oauth2/callback'
    | '/_auth/_appLayout/'
    | '/_auth/home/'
    | '/_auth/automations/$automationId/'
    | '/_auth/automations/$automationId/runs/$runId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  CallbackGitRoute: typeof CallbackGitRoute
  CallbackOauth1Route: typeof CallbackOauth1Route
  ConnectionsOauth2CallbackRoute: typeof ConnectionsOauth2CallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback/oauth1': {
      id: '/callback/oauth1'
      path: '/callback/oauth1'
      fullPath: '/callback/oauth1'
      preLoaderRoute: typeof CallbackOauth1RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback/git': {
      id: '/callback/git'
      path: '/callback/git'
      fullPath: '/callback/git'
      preLoaderRoute: typeof CallbackGitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/projects': {
      id: '/_auth/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AuthProjectsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/create': {
      id: '/_auth/create'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof AuthCreateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/account': {
      id: '/_auth/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthAccountRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/accept-invitation': {
      id: '/_auth/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AuthAcceptInvitationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_appLayout': {
      id: '/_auth/_appLayout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthAppLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/home/': {
      id: '/_auth/home/'
      path: '/home'
      fullPath: '/home/'
      preLoaderRoute: typeof AuthHomeIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_appLayout/': {
      id: '/_auth/_appLayout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthAppLayoutIndexRouteImport
      parentRoute: typeof AuthAppLayoutRoute
    }
    '/connections/oauth2/callback': {
      id: '/connections/oauth2/callback'
      path: '/connections/oauth2/callback'
      fullPath: '/connections/oauth2/callback'
      preLoaderRoute: typeof ConnectionsOauth2CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/projects/$projectId': {
      id: '/_auth/projects/$projectId'
      path: '/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AuthProjectsProjectIdRouteImport
      parentRoute: typeof AuthProjectsRoute
    }
    '/_auth/integrations/$projectId': {
      id: '/_auth/integrations/$projectId'
      path: '/integrations/$projectId'
      fullPath: '/integrations/$projectId'
      preLoaderRoute: typeof AuthIntegrationsProjectIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/home/issues': {
      id: '/_auth/home/issues'
      path: '/home/issues'
      fullPath: '/home/issues'
      preLoaderRoute: typeof AuthHomeIssuesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/home/integrations': {
      id: '/_auth/home/integrations'
      path: '/home/integrations'
      fullPath: '/home/integrations'
      preLoaderRoute: typeof AuthHomeIntegrationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/home/automations': {
      id: '/_auth/home/automations'
      path: '/home/automations'
      fullPath: '/home/automations'
      preLoaderRoute: typeof AuthHomeAutomationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_appLayout/resources': {
      id: '/_auth/_appLayout/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof AuthAppLayoutResourcesRouteImport
      parentRoute: typeof AuthAppLayoutRoute
    }
    '/_auth/_appLayout/issues': {
      id: '/_auth/_appLayout/issues'
      path: '/issues'
      fullPath: '/issues'
      preLoaderRoute: typeof AuthAppLayoutIssuesRouteImport
      parentRoute: typeof AuthAppLayoutRoute
    }
    '/_auth/_appLayout/integrations': {
      id: '/_auth/_appLayout/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AuthAppLayoutIntegrationsRouteImport
      parentRoute: typeof AuthAppLayoutRoute
    }
    '/_auth/_appLayout/automations': {
      id: '/_auth/_appLayout/automations'
      path: '/automations'
      fullPath: '/automations'
      preLoaderRoute: typeof AuthAppLayoutAutomationsRouteImport
      parentRoute: typeof AuthAppLayoutRoute
    }
    '/_auth/automations/$automationId/': {
      id: '/_auth/automations/$automationId/'
      path: '/automations/$automationId'
      fullPath: '/automations/$automationId/'
      preLoaderRoute: typeof AuthAutomationsAutomationIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/automations/$automationId/runs/$runId': {
      id: '/_auth/automations/$automationId/runs/$runId'
      path: '/automations/$automationId/runs/$runId'
      fullPath: '/automations/$automationId/runs/$runId'
      preLoaderRoute: typeof AuthAutomationsAutomationIdRunsRunIdRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthAppLayoutRouteChildren {
  AuthAppLayoutAutomationsRoute: typeof AuthAppLayoutAutomationsRoute
  AuthAppLayoutIntegrationsRoute: typeof AuthAppLayoutIntegrationsRoute
  AuthAppLayoutIssuesRoute: typeof AuthAppLayoutIssuesRoute
  AuthAppLayoutResourcesRoute: typeof AuthAppLayoutResourcesRoute
  AuthAppLayoutIndexRoute: typeof AuthAppLayoutIndexRoute
}

const AuthAppLayoutRouteChildren: AuthAppLayoutRouteChildren = {
  AuthAppLayoutAutomationsRoute: AuthAppLayoutAutomationsRoute,
  AuthAppLayoutIntegrationsRoute: AuthAppLayoutIntegrationsRoute,
  AuthAppLayoutIssuesRoute: AuthAppLayoutIssuesRoute,
  AuthAppLayoutResourcesRoute: AuthAppLayoutResourcesRoute,
  AuthAppLayoutIndexRoute: AuthAppLayoutIndexRoute,
}

const AuthAppLayoutRouteWithChildren = AuthAppLayoutRoute._addFileChildren(
  AuthAppLayoutRouteChildren,
)

interface AuthProjectsRouteChildren {
  AuthProjectsProjectIdRoute: typeof AuthProjectsProjectIdRoute
}

const AuthProjectsRouteChildren: AuthProjectsRouteChildren = {
  AuthProjectsProjectIdRoute: AuthProjectsProjectIdRoute,
}

const AuthProjectsRouteWithChildren = AuthProjectsRoute._addFileChildren(
  AuthProjectsRouteChildren,
)

interface AuthRouteChildren {
  AuthAppLayoutRoute: typeof AuthAppLayoutRouteWithChildren
  AuthAcceptInvitationRoute: typeof AuthAcceptInvitationRoute
  AuthAccountRoute: typeof AuthAccountRoute
  AuthCreateRoute: typeof AuthCreateRoute
  AuthProjectsRoute: typeof AuthProjectsRouteWithChildren
  AuthHomeAutomationsRoute: typeof AuthHomeAutomationsRoute
  AuthHomeIntegrationsRoute: typeof AuthHomeIntegrationsRoute
  AuthHomeIssuesRoute: typeof AuthHomeIssuesRoute
  AuthIntegrationsProjectIdRoute: typeof AuthIntegrationsProjectIdRoute
  AuthHomeIndexRoute: typeof AuthHomeIndexRoute
  AuthAutomationsAutomationIdIndexRoute: typeof AuthAutomationsAutomationIdIndexRoute
  AuthAutomationsAutomationIdRunsRunIdRoute: typeof AuthAutomationsAutomationIdRunsRunIdRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAppLayoutRoute: AuthAppLayoutRouteWithChildren,
  AuthAcceptInvitationRoute: AuthAcceptInvitationRoute,
  AuthAccountRoute: AuthAccountRoute,
  AuthCreateRoute: AuthCreateRoute,
  AuthProjectsRoute: AuthProjectsRouteWithChildren,
  AuthHomeAutomationsRoute: AuthHomeAutomationsRoute,
  AuthHomeIntegrationsRoute: AuthHomeIntegrationsRoute,
  AuthHomeIssuesRoute: AuthHomeIssuesRoute,
  AuthIntegrationsProjectIdRoute: AuthIntegrationsProjectIdRoute,
  AuthHomeIndexRoute: AuthHomeIndexRoute,
  AuthAutomationsAutomationIdIndexRoute: AuthAutomationsAutomationIdIndexRoute,
  AuthAutomationsAutomationIdRunsRunIdRoute:
    AuthAutomationsAutomationIdRunsRunIdRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  CallbackGitRoute: CallbackGitRoute,
  CallbackOauth1Route: CallbackOauth1Route,
  ConnectionsOauth2CallbackRoute: ConnectionsOauth2CallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
